<template>
  <div
    class="page_ blue_"
    @click="
      showArea = false;
      nowIndexTab = -1;
    "
  >
    <div class="tab_ flex_ tab_f" :class="{ long: lang == 'en-us' }">
      <div class="sele_item">
        <label for="">{{ $t("hdetail.card") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="Memctlno"
          @change="planChange"
        >
          <a-select-option
            v-for="item in planList"
            :key="item.memNO"
            :value="item.memNO"
            @click="cardSelect(item)"
            >{{ item.insured }}</a-select-option
          >
        </a-select>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.level") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="provider_level"
          @change="levelChange"
        >
          <a-select-option
            v-for="item in levelList"
            :key="item.code"
            :value="item.code"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.hospitalClass") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="provider_catg"
          @change="classChange"
        >
          <a-select-option
            v-for="item in classList"
            :key="item.code"
            :value="item.code"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.hospitalProperty") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="provider_type"
          @change="propertyChange"
        >
          <a-select-option
            v-for="item in propertyList"
            :key="item.code"
            :value="item.code"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.fullhours") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="is_fullhours"
        >
          <a-select-option value="Y">{{
            lang == "en-us" ? "Y" : "是"
          }}</a-select-option>
          <a-select-option value="N">{{
            lang == "en-us" ? "N" : "全部"
          }}</a-select-option>
        </a-select>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.emergency") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="em_cashless"
        >
          <a-select-option value="Y">{{
            lang == "en-us" ? "Y" : "是"
          }}</a-select-option>
          <a-select-option value="N">{{
            lang == "en-us" ? "N" : "全部"
          }}</a-select-option>
        </a-select>
      </div>
      <div class="sele_item">
        <label for=""
          >{{ $i18n.locale == "zh-cn" ? "医院名称" : "Provider name" }}：</label
        >
        <span class="input_" style="width:60%">
          <input
            type="text"
            :placeholder="$t('ML1[38]') || '请输入医院名称'"
            v-model="provider_name"
          />
        </span>
      </div>
      <div class="sele_item">
        <label for="">{{ $t("hdetail.province") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="state"
          optionLabelProp="children"
          show-search
          :filter-option="filterOption"
          @change="createCity"
        >
          <a-select-option
            v-for="item in dataArea"
            :key="item.refCd"
            :value="item.refCd"
            >{{ lang == "en-us" ? item.sdesc : item.fdesc }}</a-select-option
          >
        </a-select>
      </div>

      <div class="sele_item">
        <label for="">{{ $t("hdetail.city") }}：</label>
        <a-select
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          v-model="dist"
          optionLabelProp="children"
          show-search
          :filter-option="filterOption"
          @change="cityChange"
        >
          <a-select-option
            v-for="item in dataChild"
            :key="item.refCd"
            :value="item.refCd"
            >{{ lang == "en-us" ? item.sdesc : item.fdesc }}</a-select-option
          >
        </a-select>
      </div>
      <div
        class="sele_item"
        v-if="$i18n.locale == 'zh-cn'"
        style="height: 34px;"
      >
        <label for=""
          >{{ $i18n.locale == "zh-cn" ? "出发地点" : "Departure" }}：</label
        >
        <a-select
          mode="default"
          label-in-value
          :autoClearSearchValue="false"
          optionLabelProp="children"
          show-search
          :value="departureValue"
          :placeholder="$t('ML1[39]') || '请输入出发地点'"
          style="width:60%;border: 1px #E7E7E7 solid;border-radius:4px;"
          :filter-option="true"
          :not-found-content="null"
          @search="handleSearch($event)"
          @change="handleChange($event)"
        >
          <a-select-option
            v-for="d in departureList"
            :key="d.RefCd"
            :value="d.name"
            :label="d.name"
          >
            {{ d.name }}
            <span role="img" :aria-label="d.name" class="gray_">
              （{{ d.city + d.area }}）
            </span>
          </a-select-option>
        </a-select>
      </div>
      <a-button
        type="primary"
        style="margin-right:20px;margin-bottom:15px;"
        @click="search"
        >{{ $i18n.locale == "zh-cn" ? "搜索" : "Search" }}</a-button
      >
      <!-- <div class="sele_item">
      </div> -->
      <div
        class="sele_item"
        style="width:50%;align-items: flex-start;"
        v-if="
          showDistance && $i18n.locale == 'zh-cn' && this.departureValue.key
        "
      >
        <label for="" style="margin-top:5px;"
          >{{ $i18n.locale == "zh-cn" ? "距离选择" : "Distance" }}：</label
        >
        <div
          class="flex_"
          style="align-items:flex-start;flex-wrap:wrap;padding-top:5px;"
        >
          <div
            class="checkRadio"
            v-for="(item, index) in distanceOptions"
            :key="index"
            @click="changeDistance(item.value)"
            :class="{ on: distance == item.value }"
            v-if="showDistance"
          >
            <label></label>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="h_list">
      <div class="hitem" v-for="(item, index) in datalist" :key="index">
        <p>
          {{ item.provider_name }}
          <template v-if="language == 'CHINAESE'">
            <span class="icon_1" v-if="item.is_highcost === 'Y'"></span>
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_24h.jpg"
              alt=""
              v-if="item.is_fullhours === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_jizhen.jpg"
              alt=""
              v-if="item.em_cashless === 'Y'"
            />
          </template>
          <template v-if="language == 'ENGLISH'">
            <img
              class="myicon"
              src="../assets/medilinkPC/pricelevel_en.jpg"
              alt=""
              v-if="item.is_highcost === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_24h.jpg"
              alt=""
              v-if="item.is_fullhours === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_jizhen_en.jpg"
              alt=""
              v-if="item.em_cashless === 'Y'"
            />
          </template>
        </p>
        <div class="flex_">
          <div class="flex_1">
            <p class="flex_p">
              <span class="h_loc"></span><span>{{ item.address }}</span>
            </p>
            <p class="phonegray">
              <span class="h_phone"></span
              ><span
                ><span v-for="tdata in item.phoneArr" @click.stop="goTel(tdata)"
                  >{{ tdata }}&#12288;</span
                ></span
              >
            </p>
          </div>
          <div
            class="flex_2"
            v-if="departureValue.key && showDistance && $i18n.locale == 'zh-cn'"
          >
            <p>{{ $i18n.locale == "zh-cn" ? "距离" : "Distance" }}</p>
            <p>{{ item.distance ? item.distance : "无法获取距离" }}</p>
          </div>
          <div class="flex_2">
            <p>{{ $t("hdetail.hospitalProperty") }}</p>
            <p>{{ item.provider_type }}</p>
          </div>
          <div class="flex_2">
            <p>{{ $t("hdetail.hospitalClass") }}</p>
            <p>{{ item.provider_catg }}</p>
          </div>
          <div class="flex_2">
            <p>{{ $t("hdetail.level") }}</p>
            <p><span class="circle_"></span>{{ item.provider_level }}</p>
          </div>
        </div>
        <span
          @click="goDetail(item.provider_code)"
          style="border-radius:2px;"
          >{{ $t("hdetail.detail") }}</span
        >
      </div>
    </div>
    <div v-if="datalist && datalist.length > 0" class="page_wrap_">
      <a-pagination @change="handlePageChange" :total="total" :pageSize="10" />
    </div>
    <div class="noh" v-if="datalist.length === 0">
      <img class="nodata_" src="../assets/medilinkPC/nodata.jpg" alt="" />
    </div>
    <div class="fixbg1" v-if="isLoading">
      <a-spin />
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";
import { setTimeout, clearTimeout } from "timers";
export default {
  data() {
    return {
      is_fullhours: "N", //是否是24H
      em_cashless: "N", //是否是急诊
      planList: [],
      propertyList: [
        { id: 0, name: this.$t("property.all"), code: "" },
        { id: 1, name: this.$t("property.p1"), code: "1" },
        { id: 2, name: this.$t("property.p2"), code: "5" },
        { id: 3, name: this.$t("property.p3"), code: "10" }
      ],
      levelList: [],
      classList: [],
      datalist: [],
      dataArea: [],
      dataChild: [{ fdesc: "全部地区", refCd: "", sdesc: "All" }],
      state: "",
      dist: "",
      provider_type: "",
      provider_level: "",
      provider_catg: "",
      provider_name: "",
      Memctlno: "",
      language: "",
      isLoading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      lang: "",
      distName: "", //城市名称
      distance: "", //距离范围
      departureValue: "", //出发地
      departureList: [], //出发地模糊查询
      distanceOptions: [
        { label: this.$t("distanceList[0]"), value: "5" },
        { label: this.$t("distanceList[1]"), value: "10" },
        { label: this.$t("distanceList[2]"), value: "15" },
        { label: this.$t("distanceList[3]"), value: "20" },
        { label: this.$t("distanceList[4]"), value: "30" },
        { label: this.$t("distanceList[5]"), value: "0" }
      ],
      showDistance: false, //当前出发地是否有效
      isEcho: false,
      appointQuery: {}
    };
  },
  mounted() {
    this.lang = this.$i18n.locale;
    this.language = this.$i18n.locale == "en-us" ? "ENGLISH" : "CHINAESE";
    if (this.$route.query.isEcho) {
      this.isEcho = true;
    }
    this.fetchData();
  },
  watch: {
    departureValue(value) {
      if (value == "{}") {
        this.showDistance = false;
      } else {
        this.showDistance = true;
      }
    }
  },
  methods: {
		filterOption(input, option) {
			return option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0;
		},
    fetchData() {
      // 产品信息
      api.getProductOrgInfo().then(res => {
        if (
          res.data.code === 200 &&
          res.data.data != null &&
          res.data.data != "" &&
          res.data.data.length > 0
        ) {
          this.planList = res.data.data;
          const item = this.planList[0];
          let selectCard = JSON.parse(localStorage.getItem("cardList"));
          if (selectCard && selectCard.length) {
            var card = selectCard.filter(e => e.Card_no == item.cardNo);
            this.appointQuery = {
              Card_no: card[0].Card_no,
              Employee_name: card[0].Employee_name,
              Payor_code: card[0].Payor_code,
              memberNo: card[0].memberNo
            };
          }
          this.Memctlno = this.planList[0].memNO;
        }
      });
      // 省数据
      api.getReferenceInfo({ refGrp: "STATE_CHN" }).then(res => {
        if (res.data.code === 200) {
          this.dataArea = res.data.data;
          this.dataArea.unshift({ fdesc: "全部地区", refCd: "", sdesc: "All" });
        }
      });
      // 医院类别
      api.getReferenceInfo({ refGrp: "PROVTYPDISP" }).then(res => {
        if (res.data.code === 200) {
          this.classList = res.data.data.map((item, index) => {
            let desc = this.$i18n.locale == "en-us" ? item.sdesc : item.fdesc;
            let data = { id: index + 1, name: desc, code: item.refCd };
            return data;
          });
          this.classList.unshift({
            id: 0,
            name: this.$t("medicalInstitutionSearch.all"),
            code: ""
          });
        }
      });
      // 医院等级
      api.getReferenceInfo({ refGrp: "PROVIDER_LEVEL" }).then(res => {
        if (res.data.code === 200) {
          this.levelList = res.data.data.map((item, index) => {
            let desc = this.$i18n.locale == "en-us" ? item.sdesc : item.fdesc;
            let data = { id: index + 1, name: desc, code: item.refCd };
            return data;
          });
          this.levelList.unshift({
            id: 0,
            name: this.$t("medicalInstitutionSearch.all"),
            code: ""
          });
        }
      });
      this.pageNum = 1;
      this.datalist = [];
      if (this.isEcho == true) {
        this.echoSearch();
      }
    },
    echoSearch() {
      let storage_form = JSON.parse(localStorage.getItem("hospitalForm"));
      const {
        state,
        dist,
        memctlno,
        provider_type,
        provider_level,
        provider_catg,
        provider_name,
        distName,
        distance,
        showDistance
      } = storage_form;
      let departureValue = JSON.parse(localStorage.getItem("departureValue"));
      let departureList = JSON.parse(localStorage.getItem("departureList"));
      let dataChild = JSON.parse(localStorage.getItem("dataChild"));
      this.state = state;
      this.dist = dist;
      this.Memctlno = memctlno;
      this.provider_type = provider_type;
      this.provider_level = provider_level;
      this.provider_catg = provider_catg;
      this.provider_name = provider_name;
      this.distName = distName;
      this.distance = distance;
      this.departureValue = departureValue;
      this.departureList = departureList;
      this.showDistance = showDistance;
      this.dataChild = dataChild;
      this.search();
    },
    //查询医疗机构
    search() {
      let start = (this.pageNum - 1) * this.pageSize + 1;
      let end = this.pageNum * this.pageSize;
      let my_longitude_loc = "";
      let my_latitude_loc = "";
      if (this.distName && this.departureValue && this.departureValue.key) {
        let filter_ = this.departureList.filter(
          item => item.name == this.departureValue.key
        );
        if (filter_.length > 0) {
          my_longitude_loc = filter_[0].location.lng;
          my_latitude_loc = filter_[0].location.lat;
        }
      }
      let distanceMin = "";
      let distanceMax = "";
      if (this.distance != "0" && this.distance != "") {
        distanceMax = parseInt(this.distance) * 1000;
      } else if (this.distance == "0") {
        distanceMin = parseInt(30) * 1000;
      }
      let requestdata = {
        is_fullhours: this.is_fullhours,
        em_cashless: this.em_cashless,
        state: this.state,
        dist: this.dist,
        memctlno: this.Memctlno,
        provider_type: this.provider_type,
        provider_level: this.provider_level,
        provider_catg: this.provider_catg,
        provider_name: this.provider_name,
        fromRowNum: start,
        toRowNum: end,
        my_longitude_loc: my_longitude_loc,
        my_latitude_loc: my_latitude_loc,
        language: this.language,
        distanceMin: distanceMin,
        distanceMax: distanceMax
      };
      this.isLoading = true;
      if (this.Memctlno != "") {
        api.getProviderListM(requestdata).then(res => {
          if (res.data.code === 200) {
            this.isLoading = false;
            console.log(res, "res===>");
            let datalistn = res.data.data.list.map(item => {
              let phoneArr = [];
              if (
                item.telephone_No1 != null &&
                item.telephone_No1.indexOf(",") != -1
              ) {
                let phoneArr1 = item.telephone_No1.split(",");
                for (let i = 0; i < phoneArr1.length; i++) {
                  phoneArr.push(phoneArr1[i]);
                }
              } else if (
                item.telephone_No1 != null &&
                item.telephone_No1.indexOf(",") === -1
              ) {
                phoneArr.push(item.telephone_No1);
              }
              item.phoneArr = phoneArr;
              return item;
            });
            this.datalist = datalistn;
            this.total = res.data.data.total;
          } else {
            this.isLoading = false;
          }
        });
      } else {
        this.isLoading = false;
        this.$message.error(this.$t("hdetail.nodata"));
        this.datalist = [];
      }
    },
    //保险卡选择
    planChange(value) {
      console.log(value);
      // debugger
      this.memctlno = value;
      if (this.state != "") {
        api
          .getCityInfo({ provinceCode: this.state, memberNo: this.Memctlno })
          .then(res => {
            if (res.data.code === 200) {
              this.dataChild = res.data.data;
              this.dataChild.unshift({
                fdesc: "全部地区",
                refCd: "",
                sdesc: "All"
              });
            }
          });
      }
      this.provider_name = "";
      this.pageNum = 1;
    },
    //选择保险卡
    cardSelect(item) {
      let selectCard = JSON.parse(localStorage.getItem("cardList"));
      if (selectCard && selectCard.length) {
        var card = selectCard.filter(e => e.Card_no == item.cardNo);
        this.appointQuery = {
          Card_no: card[0].Card_no,
          Employee_name: card[0].Employee_name,
          Payor_code: card[0].Payor_code,
          memberNo: card[0].memberNo
        };
      }
    },
    // 选择省
    createCity(value) {
      this.provider_name = "";
      this.dist = "";
      if (value === "") {
        this.state = "";
      } else {
        this.state = value;
        api
          .getCityInfo({ provinceCode: value, memberNo: this.Memctlno })
          .then(res => {
            if (res.data.code === 200) {
              this.dataChild = res.data.data;
              this.dataChild.unshift({
                fdesc: "全部地区",
                refCd: "",
                sdesc: "All"
              });
            }
          });
      }
      this.pageNum = 1;
    },
    //城市选择
    cityChange(value) {
      this.provider_name = "";
      if (value === "") {
        this.dist = "";
        this.distName = "";
      } else {
        if (this.lang == "en-us") {
          this.distName = this.dataChild.filter(
            item => item.refCd == value
          )[0].sdesc;
        } else {
          this.distName = this.dataChild.filter(
            item => item.refCd == value
          )[0].fdesc;
        }
        this.dist = value;
      }
      this.pageNum = 1;
    },
    // 性质选择
    propertyChange(value) {
      if (value === "") {
        this.provider_type = "";
      } else {
        this.provider_type = value;
      }
      this.provider_name = "";
      this.pageNum = 1;
    },
    classChange(value) {
      if (value === "") {
        this.provider_catg = "";
      } else {
        this.provider_catg = value;
      }
      this.provider_name = "";
      this.pageNum = 1;
    },
    levelChange(value) {
      if (value === "") {
        this.provider_level = "";
      } else {
        this.provider_level = value;
      }
      this.provider_name = "";
      this.pageNum = 1;
    },
    goDetail(code) {
      let storage_data = {
        state: this.state,
        dist: this.dist,
        memctlno: this.Memctlno,
        provider_type: this.provider_type,
        provider_level: this.provider_level,
        provider_catg: this.provider_catg,
        provider_name: this.provider_name,
        language: this.language,
        distName: this.distName, //城市名称
        distance: this.distance, //距离范围
        showDistance: this.showDistance
      };
      let departureValue = {};
      if (this.departureValue && this.departureValue.key) {
        departureValue.key = this.departureValue.key;
      }
      let departureList = [];
      if (this.departureList && this.departureList.length > 0) {
        this.departureList.map(item => {
          departureList.push(item);
        });
      }
      let dataChild = [];
      if (this.dataChild && this.dataChild.length > 0) {
        this.dataChild.map(item => {
          dataChild.push(item);
        });
      }
      localStorage.setItem("hospitalForm", JSON.stringify(storage_data));
      localStorage.setItem("departureValue", JSON.stringify(departureValue));
      localStorage.setItem("departureList", JSON.stringify(departureList));
      localStorage.setItem("dataChild", JSON.stringify(dataChild));
      this.$router.push({
        path: "HospitalDetail",
        query: this.$merge(this.appointQuery, { provider_code: code })
      });
    },
    handlePageChange(e) {
      console.log("handlePageChange -> ", e);
      this.pageNum = e;
      this.search();
    },
    changeDistance(value) {
      console.log();
      if (value == this.distance) {
        this.distance = "";
      } else {
        this.distance = value;
      }
      if (this.departureValue && this.departureValue.key) {
        this.search();
      } else {
        let message =
          this.lang == "en-us"
            ? "Invalid address, please re-enter"
            : "地址无效，请重新输入";
        this.$message.warning(res.data.returnMsg);
      }
    },
    handleSearch(value) {
      if (!this.distName && value) {
        let message =
          this.lang == "en-us"
            ? "Please select city first"
            : "请选择具体的城市再查询";
        this.$message.warning(message);
        return;
      } else if (this.distName && value) {
        api
          .getBaiduMapInfo({ query: value, region: this.distName })
          .then(res => {
            if (res.data.returnCode == "0000" && res.data.content.length > 0) {
              this.departureList = res.data.content;
            } else {
              let message =
                this.lang == "en-us"
                  ? "Invalid address, please re-enter"
                  : "地址无效，请重新输入";
              this.$message.warning(message);
              this.departureList = [];
              this.departureValue = {};
              this.showDistance = false;
            }
          });
      }
    },
    handleChange(value) {
      if (value) {
        this.departureValue = value;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 10px;
}
.tab_ {
  margin: 0 auto;
  font-size: 14px;
  color: #000;
  position: relative;
  padding: 19px 30px 4px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  width: 100%;
  // justify-content: space-between;
  .selectcon_ {
    position: absolute;
    top: 37px;
    left: 170px;
    right: 0;
    background-color: #fff;
    padding: 10px;
    width: 640px;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
    &.selectcon_1 {
      left: 340px;
    }
    &.selectcon_2 {
      left: 400px;
    }
    &.selectcon_3 {
      left: 460px;
    }
    .flex_l,
    .flex_r,
    .list_ {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
    span {
      width: 25%;
      text-align: left;
      padding: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      &.on {
        color: #00a63c;
      }
    }
  }
}
.h_list {
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  color: #000;
  .hitem {
    padding: 16px 30px;
    border-bottom: 1px solid #f3f3f3;
    position: relative;
    img.myicon {
      width: 33px;
      margin-left: 8px;
      margin-top: -3px;
    }
    &:last-child {
      border: none;
    }
    > span:last-child {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 30px;
      height: 30px;
      width: 90px;
      background: #2c5acc;
      color: #fff;
      text-align: center;
      line-height: 30px;
      border-radius: 2px;
      cursor: pointer;
    }
    > p:first-child {
      color: #394155;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 3px;
      span {
        width: 30px;
        height: 16px;
        background: url(../assets/medilinkPC/pricelevel.png) center center
          no-repeat;
        display: inline-block;
        background-size: 100% 100%;
        margin-left: 5px;
        top: 2px;
        position: relative;
      }
    }

    .flex_ {
      display: flex;
      p {
        margin-bottom: 0;
      }
      .flex_1 {
        width: 30%;

        p {
          font-size: 14px;
          color: #394155;
          &:last-child {
            color: #2c5acc;
          }
        }
        .flex_p {
          display: flex;
          align-items: flex-start;
        }
        span:last-child {
          display: inline-block;
          max-width: 90%;
        }
        .h_loc {
          width: 12px;
          height: 14px;
          background: url(../assets/medilinkPC/h_loc.png) center center
            no-repeat;
          display: inline-block;
          background-size: 100% 100%;
          margin-right: 5px;
          min-width: 12px;
          top: 4px;
          position: relative;
        }
        .h_phone {
          width: 12px;
          height: 14px;
          background: url(../assets/medilinkPC/h_phone.png) center center
            no-repeat;
          display: inline-block;
          background-size: 100% 100%;
          margin-right: 5px;
        }
      }
      .flex_2 {
        min-width: 100px;
        display: flex;
        flex-direction: column;
        margin-left: 5%;
        font-size: 14px;
        color: #394155;
        p {
          display: flex;
          align-items: center;
        }
        p:last-child {
          color: #999999;
        }
        .circle_ {
          width: 5px;
          height: 5px;
          display: inline-block;
          border-radius: 5px;
          background-color: #2c5acc;
          margin-right: 5px;
        }
      }
    }
  }
}
input {
  border: none;
  background-color: transparent;
}
.page_wrap_ {
  padding-right: 30px;
  margin: 20px auto;
  text-align: right;
}
.sele_item {
  display: flex;
  align-items: center;
  // margin-right:15px;
  margin-bottom: 15px;
  // flex:1;
  // width:15%;
  width: 32%;
  margin-right: 2%;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  label {
    white-space: nowrap;
    width: 70px;
    min-width: 70px;
  }
  > span {
    color: #e7e7e7;
    cursor: pointer;
    padding: 7px 15px 10px 0px;
    &.input_ {
      padding: 0 8px;
      border: 1px solid #e7e7e7;
      border-radius: 4px;
      // width:10%;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    &.input_ input {
      padding: 6px 20px;
      height: 100%;
      background: url(../assets/medilinkPC/input.png) left center no-repeat;
      background-size: 13px 13px;
      color: #394155;
      &:focus {
        appearance: none;
        outline: 0;
      }
    }
  }
}
.flex_ {
  display: inline-flex;
  // align-items: center;
  &.tab_f {
    // justify-content: space-between;
    flex-wrap: wrap;
    // flex:6;
    margin-bottom: 0;
    &.long {
      .sele_item {
        label {
          width: 125px;
          min-width: 125px;
        }
      }
    }
  }
}
.noh {
  width: 100%;
  min-height: 50vh;
  .nodata_ {
    width: 81px;
    margin-top: 150px;
    height: 91px;
    display: block;
    margin: 150px auto 0;
  }
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
.checkRadio {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
  padding-bottom: 5px;
  label {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #efefef;
    min-width: 20px;
    margin-right: 5px;
  }
  &.on {
    label {
      background: url(../assets/medilinkPC/checkiconr.png) center center
        no-repeat #2c5acc;
      background-size: 15px 15px;
    }
  }
  span {
    white-space: nowrap;
  }
}
.gray_ {
  margin-left: 10px;
  color: #ccc;
}
</style>
